/* Placeholder for radio specific styles */